<div class="stockWrapper">
  <div
    matTooltip="{{ getWarehouse()?.warehouse?.description }}"
    [ngClass]="{
      myStock: getMyWhQuan(),
      otherStock: !getMyWhQuan()
    }"
    class="stockCell my_wh_stock"
  >
    {{ getMyWhQuan() }}
  </div>

  <div
    *ngFor="let row of getOurStockWarehousesInMyCity()"
    [ngClass]="{
      myStock: row.quan > 0,
      otherStock: row.quan <= 0
    }"
    [matTooltip]="row.warehouse.description"
    class="stockCell our_another_stock_city"
  >
    {{ row.quan }}
  </div>
  <!-- <div
    [ngClass]="{
      myStock: getProviderStockInMyCity(),
      otherStock: !getProviderStockInMyCity()
    }"
    [matTooltip]="providerStockInMyCity"
    class="stockCell our_another_stock_city"
  >
    {{ getProviderStockInMyCity() }}
  </div>
  <div
    [ngClass]="{
      myStock: getProviderStockOutMyCity(),
      otherStock: !getProviderStockOutMyCity()
    }"
    [matTooltip]="providerStockOutMyCity"
    class="stockCell our_another_stock_city"
  >
    {{ getProviderStockOutMyCity() }}
  </div> -->
</div>
